// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/get-many.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamGetManyBody,
  typeTeamGetManyOutput200,
} from "../../sdk/team/postTeamGetMany";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamGetManyQueryKey(
  payload: typeTeamGetManyBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamIds:${JSON.stringify(payload.teamIds)}`);
  return ["post:team:teamGetMany", "svc:sports-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeTeamGetManyOutput200,
    unknown,
    typeTeamGetManyOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamGetMany(
  payload: typeTeamGetManyBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamGetManyQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamGetMany(payload),
    ...resolvedOptions,
  });
}
